<template>
    <div class="relative w-full min-h-screen max-w-500 mx-auto overflow-hidden" data-cy="container_financial_health_main">
        <!-- Loading Screen -->
        <div v-if="isLoading" class="absolute inset-0 z-20 flex items-center justify-center bg-white" data-cy="container_financial_health_loading">
            <div class="flex flex-col items-center">
                <!-- Loading Spinner -->
                <div class="w-12 h-12 border-4 border-a-blue-0064ff border-t-transparent rounded-full animate-spin"></div>
                <p class="mt-4 text-16 text-a-gray-666666">กำลังโหลด...</p>
            </div>
        </div>
        
        <!-- Background Image -->
        <div v-show="!isLoading" class="absolute top-0 left-0 w-full h-full z-0">
            <img 
                :src="backgroundImage" 
                alt="Financial Health Background" 
                class="w-full h-full object-cover object-top"
            />
            <!-- Gradient Overlay -->
            <div class="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent via-transparent to-black/60"></div>
        </div>
        
        <!-- Content -->
        <div v-show="!isLoading" class="relative z-10 flex flex-col min-h-screen p-4 pb-0 pt-16">
            <!-- Logo -->
            <div class="mb-auto">
                <img 
                    :src="logoImage" 
                    alt="Bangkok Bank" 
                    class="h-10 w-auto object-contain"
                />
            </div>
            
            <!-- Main Content -->
            <div class="mb-20">
                <h1 class="text-32 font-medium leading-tight text-white mb-4">
                    มาเช็กสุขภาพการเงิน<br/>ของคุณใน 3 นาที
                </h1>
                <p class="text-16 font-normal leading-relaxed text-white opacity-90">
                    แค่ตอบคำถามไม่กี่ข้อ<br/>
                    ก็จะช่วยให้การเงินของคุณดียิ่งขึ้น
                </p>
            </div>
            
            <!-- Button Section -->
            <div class="pb-9">
                <PrimaryButton 
                    data-cy="btn_financial_health_start_quiz"
                    text="เริ่มทำแบบทดสอบ"
                    @click="startQuiz"
                />
            </div>
        </div>
    </div>
</template>

<script>
import PrimaryButton from '@/components/Button/PrimaryButton.vue';
import SurveyStatusHelper from '../helper/SurveyStatusHelper.js';

export default {
    name: "FinancialHealthMain",
    components: {
        PrimaryButton
    },
    data() {
        return {
            backgroundImage: require('@/assets/icon/healthcheck/bg.webp'),
            logoImage: require('@/assets/icon/healthcheck/logo.webp'),
            isLoading: true,
            hasSubmitted: false
        };
    },
    mounted() {
        this.checkSurveyStatus();
    },
    methods: {
        checkSurveyStatus() {
            SurveyStatusHelper.checkSurveyStatus({
                router: this.$router,
                redirectOnSubmitted: true,
                onNotSubmitted: () => {
                    this.hasSubmitted = false;
                    this.isLoading = false;
                },
                onAlreadySubmitted: () => {
                    this.hasSubmitted = true;
                    // Will be redirected to result page
                },
                onError: () => {
                    this.isLoading = false;
                }
            });
        },
        startQuiz() {
            // Navigate to quiz page
            this.$router.push({ name: 'financial-health-quiz' });
        }
    }
};
</script>

<style lang="scss" scoped>
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.animate-spin {
    animation: spin 1s linear infinite;
}
</style>
